import React, { createContext, useContext, useState, useEffect } from 'react';
import { storage } from '../utils/storage';

const WorkModeContext = createContext();

const WORK_MODE_KEY = 'digital-menu-work-mode';

// NER-1563: Citame admin is single-mode. The Resto-specific work modes
// (cashier/waiter/manager) and their dock widgets (orders/tables/cash) do not
// apply to a scheduling business, so only 'admin' (dock-free) remains. Any
// stale Resto value left in localStorage falls back to 'admin' below.
const WORK_MODE_CONFIG = {
  admin: {
    labelKey: 'workMode.admin',
    icon: 'admin_panel_settings',
    widgets: [],
    dockExpanded: false,
  },
};

export const WorkModeProvider = ({ children }) => {
  const [workMode, setWorkModeState] = useState(() => {
    const saved = storage.get(WORK_MODE_KEY);
    // Citame is admin-only; ignore any legacy Resto mode persisted previously.
    return saved && WORK_MODE_CONFIG[saved] ? saved : 'admin';
  });

  const setWorkMode = (mode) => {
    if (WORK_MODE_CONFIG[mode]) {
      setWorkModeState(mode);
      storage.set(WORK_MODE_KEY, mode);
    }
  };

  const currentConfig = WORK_MODE_CONFIG[workMode];
  const visibleWidgets = currentConfig?.widgets || [];
  const dockExpanded = currentConfig?.dockExpanded ?? true;

  useEffect(() => {
    storage.set(WORK_MODE_KEY, workMode);
  }, [workMode]);

  const value = {
    workMode,
    setWorkMode,
    workModeConfig: currentConfig,
    visibleWidgets,
    dockExpanded,
    availableModes: WORK_MODE_CONFIG,
  };

  return <WorkModeContext.Provider value={value}>{children}</WorkModeContext.Provider>;
};

export const useWorkMode = () => {
  const context = useContext(WorkModeContext);
  if (!context) {
    throw new Error('useWorkMode must be used within a WorkModeProvider');
  }
  return context;
};

export default WorkModeContext;
